import React, { useState } from 'react';
import ListBulls from './ListBulls.js';
import AddBull from './AddBull.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const Bulls = ({ screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState("list");

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}

      {(currentScreen === "list") && <ListBulls/>}
      {(currentScreen === "list") && <FAB onClick={() => setCurrentScreen("add")} />}
      {(currentScreen === "add") &&
        <AddBull
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const BullsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
  </div>
);

export default Bulls;
